import * as React from 'react';
import { Popover } from 'antd';
import { MetricsDimensionsCustomize, type MetricsDimensionsCustomizeProps } from './Customize';

export interface MetricsDimensionsCustomizePopupProps {
  customizeProps?: MetricsDimensionsCustomizeProps;
  children?: React.ReactNode;
}

export type { MetricsDimensionsCustomizeProps };

const CustomizePopup = ({ children, customizeProps }: MetricsDimensionsCustomizePopupProps) => {
  const { onCancel, onOk } = customizeProps || {};
  const [open, setOpen] = React.useState<boolean | undefined>(undefined);
  const handleOk = React.useCallback(
    (...p: unknown[]) => {
      setOpen(false);
      return (onOk as any)?.(...p);
    },
    [onOk],
  );
  const handleCancel = React.useCallback(
    (...p: unknown[]) => {
      setOpen(false);
      return (onCancel as any)?.(...p);
    },
    [onCancel],
  );

  React.useEffect(() => {
    if (!open) {
      setOpen(undefined);
    }
  }, [open]);

  return (
    <Popover
      open={open}
      trigger={['click']}
      arrow={false}
      destroyOnHidden
      content={
        <MetricsDimensionsCustomize {...customizeProps} onCancel={handleCancel} onOk={handleOk} />
      }
      styles={{
        body: { padding: 0 },
      }}
      onOpenChange={setOpen}
    >
      {children}
    </Popover>
  );
};

export const MetricsDimensionsCustomizePopup = React.memo(CustomizePopup);
